import { IAstNode } from './typings';
import { InferenceError } from '../errors';
import { inferenceAtomNode } from './atom';
import { inferenceFunctionCallNode } from './function';
import { inferenceArithmeticNode } from './arithmetic';
import { inferenceComparisonNode } from './comparison';
import { inferenceLiteralArray } from './literal-array';
import { TypeGenerator, IAstNodeType } from '../utils/type';


export default function inference(astNode: IAstNode) {
  if (!astNode) return;

  return calcute(astNode);
}

function calcute(astNode: IAstNode): IAstNodeType {


  if (astNode.type === 'Atom') {
    return inferenceAtomNode(astNode);
  }

  if (astNode.type === 'IdentifierArray') {
    // console.log(inferenceLiteralArray(inference, astNode));

    return inferenceLiteralArray(inference, astNode);
  }

  if (astNode.type === 'FunctionCall') {
    return inferenceFunctionCallNode(inference, astNode);
  }


  // 逻辑非
  if (astNode.type === 'LogicNot') {
    // if (!astNode.right) {
    //   throw new InferenceError('logicnot-value-lost','逻辑非表达式缺少比较值',astNode.);
    // }
    const rightType = calcute(astNode.right).type;
    if (rightType !== 'Boolean') {
      throw new InferenceError('invalid-logicnot-value', '非布尔类型不能参与逻辑运算', astNode.right.token);
    }
    return TypeGenerator.Boolean();
  }

  if (astNode.type === 'Comparison') {
    return inferenceComparisonNode(inference, astNode);
  }

  if (astNode.type === 'Arithmetic') {
    return inferenceArithmeticNode(inference, astNode);
  }

  throw { code: 'Unknown', message: 'inference error' };
}
